/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Toolbar_PlatformsInputs */

const id_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform`)
};

const ms_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform`)
};

const da_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforme`)
};

const de_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattformen`)
};

const en_us2_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforms`)
};

const es_es2_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plataformas`)
};

const es_mx2_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plataformas`)
};

const fil_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Platform`)
};

const fr_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plateformes`)
};

const it_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piattaforme`)
};

const hu_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platformok`)
};

const nl_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforms`)
};

const no_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattformer`)
};

const pl_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platformy`)
};

const pt_br2_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforms`)
};

const pt_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plataformas`)
};

const ro_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforme`)
};

const fi_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alustat`)
};

const sv_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plattformar`)
};

const vi_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nền tảng`)
};

const tr_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platformlar`)
};

const cs_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platformy`)
};

const bg_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платформи`)
};

const ru_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платформы`)
};

const uk_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платформи`)
};

const ar_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المنصات`)
};

const hi_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्लेटफ़ॉर्म`)
};

const th_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แพลตฟอร์ม`)
};

const ja_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラットフォーム`)
};

const zh_cn2_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforms`)
};

const zh_hant1_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforms`)
};

const ko_table_toolbar_platforms = /** @type {(inputs: Table_Toolbar_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platforms`)
};

/**
* | output |
* | --- |
* | "Platforms" |
*
* @param {Table_Toolbar_PlatformsInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const table_toolbar_platforms = /** @type {((inputs?: Table_Toolbar_PlatformsInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Toolbar_PlatformsInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_table_toolbar_platforms(inputs)
	if (locale === "ms") return ms_table_toolbar_platforms(inputs)
	if (locale === "da") return da_table_toolbar_platforms(inputs)
	if (locale === "de") return de_table_toolbar_platforms(inputs)
	if (locale === "en-US") return en_us2_table_toolbar_platforms(inputs)
	if (locale === "es-ES") return es_es2_table_toolbar_platforms(inputs)
	if (locale === "es-MX") return es_mx2_table_toolbar_platforms(inputs)
	if (locale === "fil") return fil_table_toolbar_platforms(inputs)
	if (locale === "fr") return fr_table_toolbar_platforms(inputs)
	if (locale === "it") return it_table_toolbar_platforms(inputs)
	if (locale === "hu") return hu_table_toolbar_platforms(inputs)
	if (locale === "nl") return nl_table_toolbar_platforms(inputs)
	if (locale === "no") return no_table_toolbar_platforms(inputs)
	if (locale === "pl") return pl_table_toolbar_platforms(inputs)
	if (locale === "pt-BR") return pt_br2_table_toolbar_platforms(inputs)
	if (locale === "pt") return pt_table_toolbar_platforms(inputs)
	if (locale === "ro") return ro_table_toolbar_platforms(inputs)
	if (locale === "fi") return fi_table_toolbar_platforms(inputs)
	if (locale === "sv") return sv_table_toolbar_platforms(inputs)
	if (locale === "vi") return vi_table_toolbar_platforms(inputs)
	if (locale === "tr") return tr_table_toolbar_platforms(inputs)
	if (locale === "cs") return cs_table_toolbar_platforms(inputs)
	if (locale === "bg") return bg_table_toolbar_platforms(inputs)
	if (locale === "ru") return ru_table_toolbar_platforms(inputs)
	if (locale === "uk") return uk_table_toolbar_platforms(inputs)
	if (locale === "ar") return ar_table_toolbar_platforms(inputs)
	if (locale === "hi") return hi_table_toolbar_platforms(inputs)
	if (locale === "th") return th_table_toolbar_platforms(inputs)
	if (locale === "ja") return ja_table_toolbar_platforms(inputs)
	if (locale === "zh-CN") return zh_cn2_table_toolbar_platforms(inputs)
	if (locale === "zh-Hant") return zh_hant1_table_toolbar_platforms(inputs)
	return ko_table_toolbar_platforms(inputs)
});
export { table_toolbar_platforms as "table.toolbar.platforms" }